export interface PageTitle {
	path: string;
	title: string;
}

export const pageTitles: PageTitle[] = [
	{
		path: '/login',
		title: 'Login'
	},
	{
		path: '/sign-up',
		title: 'Sign Up'
	},
	{
		path: '/password-reset',
		title: 'Forgot Password'
	},
	{
		path: '/',
		title: 'Account'
	},
	{
		path: '/payment-methods',
		title: 'Payment Methods'
	},
	{
		path: '/my-subscriptions',
		title: 'My Subscriptions'
	},
	{
		path: '/terms-of-service',
		title: 'Terms of Service'
	},
	{
		path: '/devices',
		title: 'Devices'
	},
	{
		path: '/my-invoice',
		title: 'My Invoice'
	},
	{
		path: '/order-detail',
		title: 'Order Details'
	}
];

export const notification = {
	type: {
		error: 'ERROR',
		success: 'SUCCESS'
	},
	heading: {
		error: 'Error',
		success: 'Success'
	},
	message: {
		contactInfoSuccess: 'Your account information has been saved',
		contactInfoError: 'Your account information has not been saved. Please try again',
		shippingAddressSuccess: 'Your address has been updated successfully',
		shippingAddressError: 'Your address has not been updated. Please try again',
		updatePasswordSuccess: 'Your password has been saved',
		updatePasswordError: 'Your password has not been saved. Please try again.',
		communicationPreferencesSuccess: 'Your communication preferences have been saved',
		communicationPreferencesError:
			'Your communication preferences have not been saved. Please try again',
		addCreditCardSuccess: 'Your credit card has been added',
		updateCreditCardSuccess: 'Your credit card has been updated',
		deleteCreditCardSuccess: 'Your card has been deleted',
		updatePurchasePinSuccess: 'Your purchase pin has been updated',
		logoutSuccess: 'You have been logged out successfully',
		logoutError: 'You have not been logout successfully. Please try again.',
		addProductSuccess: 'Your product has been registered',
		unRegisterProductSuccess: 'Your Product has been unregistered',
		deviceLinkedSuccess: 'Your device has been linked',
		deviceUnLinkedSuccess: 'Your device has been unlinked',
		browserBackError: 'Browser back functionality disabled.',
		signInSuccess: 'You have successfully logged in to the application.',
		termsOfServicesError: `You must agree to VIZIO's Home Terms of Use and Privacy Policy before continuing.`,
		emailConfirmError: `You must verify the email to VIZIO's Home before continuing.`,
		timeOutError: `Your request has timed out. Please reload or try again.`,
		updatePasswordMsg: 'Update password to continue.',
		processRequestError: 'Unable to process your request. Please try again later.',
		loggedOuError: 'You are logged out. Please log in to continue'
	}
};

export const isMobile =
	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
	(navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

export const dateFormat = 'MM/dd/yy';
export const currencySymbol = '$';

export const reactDropDownStyles = {
	container: (provided: any) => ({
		...provided,
		width: 'auto'
	}),
	placeholder: (provided: any) => ({
		...provided,
		color: '#ffffff',
		marginLeft: '8px',
		padding: '3px',
		fontSize: '14px',
		fontWeight: 'bold'
	}),
	valueContainer: (provided: any) => ({
		...provided,
		minHeight: 'auto',
		display: 'flex',
		padding: '0',
		position: 'absolute'
	}),
	input: (provided: any) => ({
		...provided,
		margin: 0,
		padding: 0,
		height: '1px'
	}),
	singleValue: (provided: any) => ({
		...provided,
		color: '#fff',
		margin: 0,
		fontFamily: 'Benton Sans Medium',
		fontSize: '14px',
		maxWidth: '50px'
	}),
	control: (provided: any, state: any) => ({
		...provided,
		backgroundColor: '#727272',
		display: 'flex',
		alignItem: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		paddingRight: '6px',
		position: 'relative',
		boxShadow: state.isFocused ? '0 0 0 1px transparent' : '0 0 0 1px #fff',
		width: '92px',
		minHeight: '32px',
		height: '32px',
		border: '1px solid #111212',
		outline: state.isFocused ? '2px solid #000 !important' : '1px solid transparent',
		outlineOffset: state.isFocused ? '2px' : '0px',
		':hover': {
			borderColor: '#757575'
		}
	}),
	indicatorsContainer: (provided: any) => ({
		...provided,
		position: 'absolute',
		right: '9px',
		top: '50%',
		transform: 'translateY(-50%)'
	}),
	dropdownIndicator: (provided: any) => ({
		...provided,
		padding: 0,
		fontSize: '11px',
		color: '#fff',
		':hover': {
			color: '#fff'
		}
	}),
	menu: (provided: any) => ({
		...provided,
		marginTop: '3px',
		boxShadow: 'none',
		backgroundColor: '#fff',
		borderTop: 0,
		borderRadius: 0,
		borderBottomRightRadius: '4px',
		borderBottomLeftRadius: '4px',
		marginBottom: 0,
		width: '150px',
		zIndex: '2',
		left: '-56px'
	}),
	menuList: (provided: any) => ({
		...provided,
		color: '#757575',
		fontFamily: 'Benton Sans Book',
		fontSize: '14px',
		margin: 0,
		padding: 0
	}),
	option: (provided: any, state: any) => ({
		...provided,
		color:
			state.data.value === 'remove' || state.data.value === 'unregister' ? '#AD2E14' : '#111212',
		backgroundColor: state.isFocused ? '#eee' : state.isSelected ? 'transparent' : '#d8d8d8',
		fontFamily: 'Benton Sans Regular',
		fontSize: '14px',
		fontWeight: 'bold',
		border: '1px solid #fbfbfb',
		transition: 'all 0.3s ease-in-out',
		margin: 0,
		cursor: 'pointer'
	})
};

export const reactSelectStyles = {
	container: (provided: any) => ({
		...provided,
		width: 'auto'
	}),
	valueContainer: (provided: any) => ({
		...provided,
		minHeight: 'auto',
		display: 'inline-block',
		padding: '12px 36px 5px 30px'
	}),
	input: (provided: any) => ({
		...provided,
		margin: 0,
		padding: 0,
		height: '1px'
	}),
	singleValue: (provided: any) => ({
		...provided,
		color: '#757575',
		margin: 0,
		fontFamily: 'Benton Sans Medium',
		fontSize: '14px'
	}),
	control: (provided: any, state: any) => ({
		...provided,
		border: '1px solid #757575',
		backgroundColor: 'transparent',
		display: 'inline-block',
		cursor: 'pointer',
		minHeight: 'auto',
		width: '100%',
		paddingRight: '6px',
		position: 'relative',
		boxShadow: state.isFocused ? '0 0 0 1px #000' : '0 0 0 1px transparent',
		':hover': {
			borderColor: '#757575'
		}
	}),
	indicatorsContainer: (provided: any) => ({
		...provided,
		position: 'absolute',
		right: '22px',
		top: '50%',
		transform: 'translateY(-50%)'
	}),
	dropdownIndicator: (provided: any) => ({
		...provided,
		padding: 0,
		fontSize: '11px',
		color: '#757575'
	}),
	menu: (provided: any) => ({
		...provided,
		marginTop: '-3px',
		boxShadow: 'none',
		padding: '0 0 5px',
		border: '1px solid #757575',
		backgroundColor: '#fff',
		borderTop: 0,
		borderRadius: 0,
		borderBottomRightRadius: '4px',
		borderBottomLeftRadius: '4px',
		marginBottom: 0,
		width: '100%'
	}),
	menuList: (provided: any) => ({
		...provided,
		color: '#757575',
		fontFamily: 'Benton Sans Book',
		fontSize: '14px',
		margin: 0,
		padding: 0
	}),
	option: (provided: any, state: any) => ({
		...provided,
		color: 'rgba(0, 0, 0, 0.8)',
		backgroundColor: state.isFocused ? '#eee' : state.isSelected ? 'transparent' : '#fff',
		fontWeight: state.isSelected ? 'bold' : 'normal',
		transition: 'all 0.3s ease-in-out',
		paddingLeft: '40px',
		paddingRight: '6px',
		paddingBottom: '8px',
		paddingTop: '8px',
		margin: 0,
		cursor: 'pointer'
	})
};
